<template>
  <SectionContainerPage>
    <SectionUserList
      xs12
      :userList="userList"
      @onEditUserClicked="
        (val) => [
          (userToEdit = val.userToEdit),
          (showDialogFormUserEdit = true),
        ]
      "
      :isLoading="isLoading"
      :shouldShowSearch="true"
    />
    <DialogFormUserEdit
      :showDialog="showDialogFormUserEdit"
      :userToEdit="userToEdit"
      @onCancelClicked="showDialogFormUserEdit = false"
      @onSubmitClicked="(val) => [onDialogFormUserEditSubmit(val)]"
      :isLoading="isLoading"
    />
    <DialogFormConfirmation
      :showDialog="confirmationDialogShow"
      :title="confirmationDialogTitle"
      :message="confirmationDialogMessage"
      :submitButtonText="confirmationDialogSubmitButtonText"
      :submitButtonIcon="confirmationDialogSubmitButtonIcon"
      :submitButtonColor="confirmationDialogSubmitButtonColor"
      :cancelButtonText="confirmationDialogCancelButtonText"
      :showCancelButton="confirmationDialogShowCancelButton"
      @onSubmitClicked="onConfirmationDialogSubmitClicked"
      @onCancelClicked="onConfirmationDialogCancelClicked"
      :isLoading="isLoading"
    />
  </SectionContainerPage>
</template>

<script>
import mixinAssetApi from '../../../common/mixins/mixinAssetApi'
import mixinAssetHelper from '../../../common/mixins/mixinAssetHelper'
import mixinConfirmationDialog from '../../../common/mixins/mixinConfirmationDialog'

import SectionContainerPage from '../../../common/components/layouts/SectionContainerPage'
import SectionUserList from './sections/SectionUserList'
import DialogFormUserEdit from '../dialogs/DialogFormUserEdit'
import DialogFormConfirmation from '../dialogs/DialogFormConfirmation'

export default {
  components: {
    SectionContainerPage,
    SectionUserList,
    DialogFormUserEdit,
    DialogFormConfirmation,
  },
  mixins: [mixinAssetApi, mixinAssetHelper, mixinConfirmationDialog],
  props: {},
  data: () => ({
    showDialogFormUserAdd: false,
    showDialogFormUserEdit: false,
    userList: [],
    userToEdit: {},
    isLoadingCount: false,
  }),
  activated() {
    this.fetchLists()
  },
  computed: {
    isLoading() {
      return this.isLoadingCount > 0
    },
  },
  watch: {
    isLoading() {
      this.$emit('isLoadingChange', this.isLoading)
    },
  },
  methods: {
    onDialogFormUserEditSubmit(data) {
      this.isLoadingCount++
      this._updateUser({
        id: data.id,
        isEnabled: data.isEnabled,
        successCb: () => {
          this.isLoadingCount--
          this.showDialogFormUserEdit = false
          this.fetchLists()
          this.$emit('notify', { message: 'User successfully updated!' })
        },
        failedCb: (error) => {
          this.isLoadingCount--
          this.showConfirmationDialog({
            title: 'Error occured',
            showCancelButton: false,
            message: this._getMessageFromErrorResponse(error),
            submitButtonText: 'Continue',
          })
        },
      })
    },
    fetchLists() {
      this.isLoadingCount++
      this._fetch({
        types: ['User'],
        successCb: (data) => {
          this.isLoadingCount--
          this.userList = data.users
        },
        failedCb: (error) => {
          this.isLoadingCount--
          this.userList = []
          this.showConfirmationDialog({
            title: 'Error occured',
            showCancelButton: false,
            message: this._getMessageFromErrorResponse(error),
            submitButtonText: 'Continue',
          })
        },
      })
    },
  },
}
</script>
